import {
  ICardAndConfig,
  IInvoiceRow,
  IPaymentHistoryRow
} from '../../services/service-mappers/SubscriptionChargesServiceMapper';
import {
  SET_SUBSCRIPTION_CHARGES_CARD_AND_CONFIG_DETAILS,
  SET_SUBSCRIPTION_CHARGES_INVOICES,
  SET_SUBSCRIPTION_CHARGES_PAYMENT_HISTORY
} from '../actions/Index';
import {SubscriptionChargesAction} from '../actions/SubscriptionChargesService';

interface SubscriptionChargesState extends ICardAndConfig {
  invoices: IInvoiceRow[];
  paymentHistory: IPaymentHistoryRow[];
}

const initState: SubscriptionChargesState = {
  card: null,
  charge: null,
  config: null,
  invoices: [],
  paymentHistory: []
};

export default function (
  state: SubscriptionChargesState = initState,
  action: SubscriptionChargesAction
): SubscriptionChargesState {
  switch (action.type) {
    case SET_SUBSCRIPTION_CHARGES_CARD_AND_CONFIG_DETAILS:
      return {
        ...state,
        ...action.payload.config
      };
    case SET_SUBSCRIPTION_CHARGES_INVOICES:
      return {
        ...state,
        invoices: action.payload.invoices
      };
    case SET_SUBSCRIPTION_CHARGES_PAYMENT_HISTORY:
      return {
        ...state,
        paymentHistory: action.payload.paymentHistory
      };
    default:
      return state;
  }
}
